import React, { useEffect, useState } from 'react';
import { SetSelectedBoxes, deleteFavoriteBox, updateFavoriteBox, getSetFavoriteBox } from '../../../actions/EpikBoxes';
import { useDispatch, useSelector } from 'react-redux';
import { Alert } from 'reactstrap';
import SortIcons from '../../ProposalsSortIcons';
import EpixBoxesListRow from './EpixBoxesListRow';

const EpikBoxesList = ({
  onBoxClick,
  boxList,
  onBoxDelete,
  onUpdateBox,
  online,
  user,
  updateBoxMonitor,
  deleteMode,
  onRecover,
  filter,
  showNotesModal,
  selectedBox,
  filterApplied,
  sortValue,
  onSort,
  onFavorites,
  onRemoveStatus
}) => {
  const dispatch = useDispatch();
  const token = localStorage.getItem('jwtToken') || null;

  const checkedBox = useSelector(state => state.UIState.epikBoxes.selectedBoxes);
  const favBoxes = useSelector(state => state.AppState.getSetFavBoxes)
  const favoriteBoxes = useSelector(state => state.AppState.favoriteBoxes);
  const [userFavoriteBoxes, setUserFavoriteBoxes] = useState([]);
  const [updatedBoxList, setUpdatedBoxList] = useState(boxList);
  
  useEffect(() => {
    setUpdatedBoxList(boxList);
  }, [boxList]);

  useEffect(() => {
    if (favBoxes?.length) {
      setUserFavoriteBoxes(favBoxes);
    } else {
      const newFavBoxes = favoriteBoxes?.filter(box => !userFavoriteBoxes?.includes(box._id)).map(filteredBox => filteredBox._id);
      setUserFavoriteBoxes([...userFavoriteBoxes, ...newFavBoxes]);
    }
  }, []);

  function handleBoxCheck(checked, box) {
    if (checked) dispatch(SetSelectedBoxes([...checkedBox, box._id]));
    else {
      const filterBox = checkedBox.filter(id => id !== box._id);
      dispatch(SetSelectedBoxes(filterBox));
    }
  }

  const onAddFavorite = async box => {
    const favoriteStatus = await dispatch(updateFavoriteBox(token, box?._id))
    if (!favoriteStatus) return;

    setUserFavoriteBoxes([...userFavoriteBoxes, box?._id]);
    dispatch(getSetFavoriteBox([...userFavoriteBoxes, box?._id]))
  };

  const onRemoveFavorite = async box => {
    const favoriteStatus = await dispatch(deleteFavoriteBox(token, box?._id))
    onRemoveStatus()
    if (!favoriteStatus) return;

    const removedList = updatedBoxList?.filter(item => item?._id !== box._id);
    const removeFromUser = userFavoriteBoxes?.filter(item => item !== box?._id);
    setUserFavoriteBoxes(removeFromUser);
    setUpdatedBoxList(removedList);

    console.log('removeFromUser______________________', removeFromUser);

    dispatch(getSetFavoriteBox(removeFromUser))
  };

  // useMemo(() => dispatch(SetSelectedBoxes([])), [boxList]);

  return (
    <>
      <div className="table-header-fixed">
        <table className="provisionList">
          <thead>
            <tr>
              <th className="check-index">
                <label className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    onChange={e => {
                      if (e.target.checked) dispatch(SetSelectedBoxes(updatedBoxList?.map(box => box._id)));
                      else dispatch(SetSelectedBoxes([]));
                    }}
                    checked={checkedBox.length}
                    className="custom-control-input"
                  />
                  <span className="custom-control-label ml-1"></span>
                </label>
              </th>
              <th>Company</th>
              <th className="cursor-pointer" onClick={() => onSort('boxName')}>
                Edge Device name <SortIcons sortObj={sortValue} sortName="boxName" />
              </th>
              <th>Serial Number</th>
              <th className="cursor-pointer" onClick={() => onSort('lastUpdated')}>
                Last Updated <SortIcons sortObj={sortValue} sortName="lastUpdated" />
              </th>
              <th>Location</th>
              <th>Registration</th>
              <th className="cursor-pointer" onClick={() => onSort('ports')}>
                Ports <SortIcons sortObj={sortValue} sortName="ports" />
              </th>
              <th>Notes </th>
              <th className="header-index">Monitoring</th>
              <th className='header-index'>Actions</th>
            </tr>
          </thead>
          <tbody>
            {updatedBoxList.length ? (
              updatedBoxList.map((box, i) => (
                <EpixBoxesListRow
                  checked={checkedBox.includes(box._id)}
                  onBoxCheck={handleBoxCheck}
                  filterApplied={filterApplied}
                  onRecover={onRecover}
                  deleteMode={deleteMode}
                  box={box}
                  user={user}
                  key={i}
                  unmonitored
                  online={online}
                  selectedBox={selectedBox}
                  showNotesModal={showNotesModal}
                  updateBoxMonitor={updateBoxMonitor}
                  onBoxClick={onBoxClick}
                  onBoxDelete={onBoxDelete}
                  onUpdateBox={onUpdateBox}
                  onAddFavorite={() => onAddFavorite(box)}
                  onRemoveFavorite={() => onRemoveFavorite(box)}
                  userFavoriteBoxes={userFavoriteBoxes}
                />
              ))
            ) : (
              <tr>
                <td colSpan={10}>
                  <Alert rowSpan={10} color="info">
                    No boxes for the{' '}
                    {filter === 'company'
                      ? 'company'
                      : filter === 'obiNumberFilter'
                        ? 'EPI Number'
                        : 'Edge Device Name'}
                    found.
                  </Alert>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default EpikBoxesList;
